import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=7fa7b9de&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=7fa7b9de&prod&scoped=true&lang=css"
import style1 from "./ProductDetails.vue?vue&type=style&index=1&id=7fa7b9de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa7b9de",
  null
  
)

export default component.exports